import React from 'react';
import SkeletonBlock from '../ui/SkeletonBlock';
import SkeletonRoot from '../ui/SkeletonRoot';
import AdminListTableSkeleton from './AdminListTableSkeleton';
import { StatTileSkeleton } from './dashboardChartSkeletons';

/**
 * In-page and route-level skeleton for /admin/leads — not the admin dashboard layout.
 */
const AdminLeadsPageSkeleton: React.FC<{ loadingLabel?: string }> = ({
  loadingLabel = 'Loading leads',
}) => (
  <SkeletonRoot loadingLabel={loadingLabel}>
    <div className="min-h-screen bg-white">
      <div className="mx-auto max-w-[1400px] space-y-4 px-4 py-4 sm:px-6 lg:px-8">
        <div className="mb-4 flex flex-col justify-between gap-4 sm:flex-row sm:items-center">
          <SkeletonBlock className="h-8 w-52 rounded-lg" />
          <SkeletonBlock className="h-9 w-full rounded-lg sm:w-60" />
        </div>

        <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
          <StatTileSkeleton />
          <StatTileSkeleton />
          <StatTileSkeleton />
        </div>

        <div className="mb-4 flex flex-wrap gap-3 border-b border-slate-200 pb-3" aria-hidden>
          {Array.from({ length: 5 }).map((_, i) => (
            <SkeletonBlock key={i} className="h-8 w-28 rounded-md" />
          ))}
        </div>

        <AdminListTableSkeleton
          embedded
          showPageShell={false}
          filterSlotCount={2}
          rowCount={8}
        />
      </div>
    </div>
  </SkeletonRoot>
);

export default AdminLeadsPageSkeleton;
